<template>
    <div class="bg-fff" :style="{'min-height':pageHeight+'px'}">
        <div class="local-upload page-content" id="local-upload" style="min-height:700px">
            <div class="file" style="padding-top:35px;padding-bottom:60px;">
                <p class="title">上传清单xls文件申请询价</p>
                <my-upload
                        :format="['xls','xlsx']"
                           :type="type"
                           :maxSize="200*1024"
                           @success="handleSuccess"
                           @uploadError="handleUploadError"
                           @formatError="handleFormatError"
                           @maxSizeError="handleMaxSizeError"
                           @progress="handleProgress"
                >
                    <div slot="style">
                        <div class="upload-default">
                            <div class="icon">
                                <i style="font-size: 67px;" class="iconfont icon-xls1"></i>
                                <!--<i v-else style="font-size: 67px;" class="iconfont icon-exl"></i>-->
                            </div>
                            <p v-if="!quoted.localFile.name&&uploadProgress === 0 && !errorText">
                                请拖xls文件到此处或点击上传
                            </p>
                            <p v-if="!quoted.localFile.name&&uploadProgress === 0 && errorText" style="color:#E14B5D;">
                                {{errorText}}
                            </p>
                            <p v-if="!quoted.localFile.name&&uploadProgress > 0&&!errorExl">
                                文件上传中…
                            </p>
                            <p v-if="!quoted.localFile.name&&uploadProgress > 0&&errorExl" style="color:#E14B5D;">
                                文件上传失败
                            </p>
                            <p v-if="quoted.localFile.name && !errorText">
                                {{quoted.localFile.name}}
                            </p>
                            <p v-if="quoted.localFile.name && errorText" style="color:#E14B5D;">
                                {{errorText}}
                            </p>
                            <!--<p>-->
                            <!--文件大小 <span class="red-font">200M</span> 以内-->
                            <!--</p>-->

                            <div class="textDetail" v-if="isZhulogic">
                                <div class="leterEgg">
                                    <span class="text">本次报价所需</span>
                                    <span class="need" v-if="points > 0" style="width:154px;">
                                        {{points || 0}}
                                    </span>
                                    <span class="need" v-else style="width:154px;">
                                        文件上传完毕后显示
                                    </span>
                                    <span class="text">恐龙蛋</span>
                                </div>
                            </div>

                            <div v-if="quoted.localFile.name&&!uploadProgress" class="uploadBUtton"><span>重新上传</span></div>
                            <div v-else class="uploadBUtton"><span>上传文件</span></div>

                        </div>
                        <div class="progress-loading" v-if="uploadProgress > 0 && !errorExl">
                            <span v-if="uploadProgress > 0 && !errorExl" :style="{'width': uploadProgress + '%'}"></span>
                            <span v-if="errorExl" :style="{'width': uploadProgress + '%'}" style="background: #E14B5D;"></span>
                        </div>
                    </div>
                </my-upload>
                <div class="textDetail" v-if="isZhulogic">
                    <div class="leterEgg">
                        <span class="xing-specail"></span>
                        <span class="text">每款产品将花费4个恐龙蛋，价格有效期为3个月</span>
                        <!-- <span class="clickDown" @click="downExcel">使用模版清单享5折优惠！点击下载</span> -->
                    </div>
                </div>
                <div class="oper-btn">
                    <!-- <button :disabled="(!busy && points > 0) ? false : true" class="green-btn"  @click="submit">
                        申请报价
                    </button> -->
                    <!--<button class="cancel-btn"  @click="cancel" :disabled="busy">-->
                        <!--取消-->
                    <!--</button>-->
                    <Enquiry :lists="quoted" :type="2" :points="points"></Enquiry>
                </div>
                <!--<div class="footer-ex">-->
                    <!--<p>-->
                        <!--<span class="left" v-if="isZhulogic">使用住逻辑模版申请报价，所需恐龙蛋享受5折优惠！</span>-->
                        <!--<span class="right" @click="downExcel"><i class="iconfont icon-export"></i>下载模板</span>-->
                    <!--</p>-->
                    <!--<div class="clr"></div>-->
                    <!--<div class="img">-->
                        <!--<img src="../../../images/uploadex.png" alt="">-->
                    <!--</div>-->
                <!--</div>-->
            </div>
        </div>
        <egglack-box ref="egglack" :text="text" :type="dialogType"></egglack-box>
        <egglack-box ref="egglackCC" :text="text" :type="dialogType2"></egglack-box>
        <delete-confirm ref="deleteConfirm" @confirm="removeList"></delete-confirm>
    </div>
</template>
<script>
    import myUpload from '../../common/myUpload.vue'
    import api from '../../../api'
    import store from '../../../store'
    import egglackBox from '../../common/eggLack.vue'
    import deleteConfirm from '../../common/deleteConfirm.vue'
    import config from '../../../config/config'
    import Enquiry from '../quoting/enquiry.vue'
    export default{
        data(){
            return {
                quoted: {
                    localFile: {},
                    remark: '',
                },
                type:4,
                uploadProgress: 0,
                uploadErrorMdl: false,
                pageHeight:window.innerHeight-64,
                busy:false,
                points: null,
                text: ' 恐龙蛋余额不足，无法报价',
                dialogType: 1,
                dialogType2: 3,
                imgBaseUrl: api.common.imgBaseUrl,
                isZhulogic: config.isZhulogic,
                errorExl: false,
                errorText: null
            }
        },
        components: {
            myUpload,
            egglackBox,
            deleteConfirm,
            Enquiry
        },
        computed: {
            balance() {
                return this.$store.state.app.balance
            },
            user() {
                return this.$store.state.user.info
            }
        },
        methods: {
            clear(name){
                this.quoted[name] = '';
            },
            downExcel(){
              api.detailedLists.download_excel()
                  .then(res => {
                      if(res){
                          window.downloadFile(this.imgBaseUrl+res.key);
                      }else{
                         this.$Message.error('下载失败，请重试！')
                      }
                  })
            },
            submit(){
                if (!this.quoted.localFile.name) {
                    this.$Message.warning('请先上传成功一个文件,再申请报价');
                    return false;
                }
                if(this.isZhulogic){
                    if(parseInt(this.balance) < parseInt(this.points)){
                        this.$refs.egglack.open()
                        return false
                    }
                    if(parseInt(this.balance) < parseInt(this.points) || this.balance === 0){
                        this.$refs.egglack.open()
                        return false
                    }
                }
                this.busy = true;
                api.detailedLists.applyQuoted(this.quoted)
                    .then((res) => {
                        this.busy = false;
                        this.$Message.success('保存成功');
                        this.$router.push({name: 'applySubmitSuc',params:{id:0, type: 1}});
                    });
            },
            cancel(){
                this.$refs.deleteConfirm.open({
                    text:'放弃本次编辑？'
                });
            },
            removeList(){
                this.$router.push(this.$route.query.redirect || {path: '/'});
            },
            handleSuccess(data){
                this.quoted.localFile = data.data[0];
                this.uploadProgress = 0;
                this.errorExl = false;
                api.enquiry.excel_blance({id: data.data[0].id})
                    .then(res => {
                        if(res > 0){
                            this.points = res
                            this.errorText = null;
                        }else{
                            this.errorText = '清单无法解析，请上传带有产品图片的清单';
                            this.$Message.warning('清单无法解析，请上传带有产品图片的清单')
                            this.points = 0;
                            this.quoted.localFile = [];
                        }
                    })
                    .catch((err) => {
                        this.errorText = err.data.message;
                        this.points = 0;
                    })

            },
            handleUploadError(){
                this.errorExl = true;
                this.errorText = '上传失败,请重新上传';
                this.$Message.error('上传失败,请重新上传');
            },
            handleFormatError(){
                this.errorText = '请选择 excel 格式的文件';
                this.$Message.error('请选择 excel 格式的文件');
            },
            handleMaxSizeError(){
                this.errorText = '请选择小于 200M 的文件';
                this.$Message.error('请选择小于 200M 的文件');
            },
            handleProgress(progress){
                this.errorText = false;
                if(progress<100) {
                    this.uploadProgress = progress;
                }else {
                    this.uploadProgress = 99;
                }
            },
        },
        created() {
            this.$store.dispatch('getBalance')
        }
    }
</script>
<style>
    #local-upload .ivu-upload-select{
        width: 100%;
    }
</style>

<style scoped>
    .modal-btn {
        margin-top: 20px;
    }

    .modal-btn button {
        width: 104px;
        height: 28px;
        background: #EFEFEF;
        border-radius: 100px;
        height: 28px;
        border: 0 none;
        color: #555;
        font-size: 12px;
    }

    .file {
        margin: 0 auto;
        width: 1130px;
    }
    .file .title{
        font-size: 24px;
        color: #353838;
        margin-bottom: 15px;
    }

    .file .file-preview,
    .file .file-progress,
    .file .upload-default {
        width: 1130px;
        height: 420px;
        /*background: #F2F4F5;*/
        text-align: center;
        overflow: hidden;
        /*border-radius: 10px;*/
        position: relative;
        /* border: 4px dashed #CACECE; */
        border-bottom: none;
        background:rgba(247,247,247,1);
    }
    .file .progress-loading{
        width: 1130px;
        height: 16px;
        background: #C8CCCC;
        position: relative;
    }
    .file .progress-loading span{
        display: inline-block;
        height: 100%;
        left: 0px;
        top:0px;
        background: #99C72C;
    }
    /* .file .upload-default:hover {
        background: #F2F4F5;
    } */
    .file .upload-default p{
        font-size: 20px;
        color: #353838;
        margin-top: 25px;
    }
    .file .file-preview .upload {
        position: absolute;
        right: 20px;
        bottom: 20px;
    }
    .file .file-preview .icon .iconfont{
        font-size:74px;
    }
    .file .file-preview .icon .icon-xls{
        font-size: 67px !important;
    }
    .file .icon {
        width: 74px;
        height: 74px;
        line-height: 74px;
        margin: 87px auto 10px;
    }
    .file .icon .icon-arrow-up {
        font-size: 34px;
        color: #A2A2A8;
    }
    .file .file-preview .iconfont{
        color:#6C6F70;
    }
    .file .file-preview p {
        color:#6C6F70;
        width: 252px;
        margin: 0 auto;
        overflow: hidden;
        white-space: nowrap;
        -ms-text-overflow: ellipsis;
        text-overflow: ellipsis;
    }

    .file .file-preview .upload button {
        background: #308697;
        color: #fff;
        border: 0 none;
        width:104px;
        border-radius:4px;
    }
    .file .file-preview .upload button i,
    .file .file-preview .upload button span{
        font-size: 12px;
        color:#fff;
    }

    .file .file-preview .upload button i {
        margin-right: 10px;
    }

    .remark {
        margin-top: 20px;
        position: relative;
    }
    .uploadBUtton{
        text-align: center;
        margin-top: 24px;
    }
    .uploadBUtton span{
        display: inline-block;
        width: 132px;
        height: 39px;
        background: #313131;
        text-align: center;
        line-height: 39px;
        font-size: 14px;
        color: #FFFFFF;
        cursor: pointer;
    }
    .uploadBUtton span:hover{
        opacity: 0.8;
    }

    .textDetail > p{
        font-size: 14px;
        color: #E14B5D;
        margin-top: 20px;
    }
    .textDetail .leterEgg{
        margin-top: 20px;
        vertical-align: middle;
        font-size: 16px;
        color: #00002E;
    }
    .textDetail .leterEgg > .xing{
        color: #E14B5D;
    }
    .textDetail .leterEgg > .text{
        display: inline-block;
        font-size: 16px;
        color: #00002E;
        vertical-align: middle;
    }
    .textDetail .leterEgg > .need{
        display: inline-block;
        width: 130px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background: #DCE0E0;
        border-radius: 2px;
        font-size: 14px;
        color: #6C6F70;
        margin-left: 20px;
        margin-right: 20px;
    }
    .textDetail .leterEgg > .xing-specail{
        display: inline-block;
        width: 12px;
        height: 12px;
        background: #F5A623;
        border-radius: 50%;
        vertical-align: middle;
        margin-right: 12px;
    }
    .textDetail .leterEgg > .clickDown{
        padding: 4px 13px;
        background: #F5A623;
        border-radius: 100px;
        font-size: 14px;
        color: #FFFFFF;
        margin-left: 12px;
        vertical-align: bottom;
        cursor: pointer;
    }
    .textDetail .leterEgg > .clickDown:hover{
        opacity: 0.8;
    }

    .remark i.icon-close {
        position: absolute;
        font-size: 12px;
        color: rgba(0, 0, 0, 0.65);
        top: -18px;
        right: 8px;
    }

    .file textarea {
        width: 628px;
        height: 98px;
        background: #F2F4F5;
        font-size: 12px;
        color: #6C6F70;
        padding: 10px 20px;
        border: 0 none;
        border-radius: 10px;
    }
    .oper-btn{
        margin-top:54px;
        text-align:center;
    }
    .oper-btn button {
        width: 317px;
        height: 50px;
        line-height: 50px;
        border-radius: 0;
        /*background: #E14B5D !important;*/
    }
    .oper-btn button:disabled{
        background: #efefef;
        color: #fff;
    }
    .green-btn{
        background: #E14B5D !important;
    }
    .green-btn:hover{
        opacity: 0.8;
    }
    .green-btn:disabled{
        background: #c8cccc !important;
        cursor: default;
        color: #ffffff;
    }
    .footer-ex{
        margin-top: 200px;
    }
    .footer-ex p .left{
        font-size: 14px;
        color: #E14B5D;
        float: left;
    }
    .footer-ex p .right{
        font-size: 14px;
        color: #353838;
        float: right;
        cursor: pointer;
    }
    .footer-ex p .right i{
        display: inline-block;
        margin-right: 5px;
    }
    .footer-ex p .right:hover{
        color: #308697;
    }
    .footer-ex .img{
        margin-top: 10px;
        border:1px solid #ddd;
    }
</style>
<style>
    .give-up-mdl .ivu-modal-body .oper-btn button {
        width: 86px;
    }

    .give-up-mdl .ivu-modal-body .oper-btn .submit-btn {
        background: #F4D03C;
    }

    .give-up-mdl .ivu-modal-body .oper-btn button:last-child {
        margin-left: 40px;
    }
</style>